import { $userLanguage, $userToken } from '@/entities/user'
import { $favoriteGames } from '@/entities/platforms/steam/store'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { useCallback, useEffect } from 'react'
import AppLoading from '@/features/loading'
import { GamesInfo } from '@/shared/ui/gameInfo'
import { getRecommendationsFx } from '@/entities/platforms/steam/effects'

export const RecommendationsView = () => {
  useHideNav()
  const userToken = useUnit($userToken)

  const handleBack = useCallback(() => {
    window.history.back()
  }, [])

  useBackButton({
    onBack: handleBack,
  })

  useEffect(() => {
    if (!userToken) return
    getRecommendationsFx(userToken)
  }, [userToken])

  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const recommendations = lang[userLang].pages.recommendations
  const recommendedGames = useUnit($favoriteGames)

  if (!recommendedGames) return <AppLoading />
  return (
    <div className={classes.root}>
      <br />
      <div className={classes.header}>
        <h1 className={classes.title}>{recommendations.title}</h1>
        <h2 className={classes.subtitle}>{recommendations.subtitle}</h2>
      </div>
      <br />
      <br />
      <div className={classes.content}>
        {recommendedGames.map((game) => (
          <GamesInfo
            key={game.appid}
            id={game.appid}
            title={game.name}
            img={game.icon_img_url}
          />
        ))}
      </div>
    </div>
  )
}
